export enum PerformanceIndicator {
  Unknown = 0,
  ReviewAtRandomAfterTwoYears = 1,
  ReviewNextYear = 3,
  CoreCriteriaNotMet = 4
}
